import type { IContainer } from '../interface/container';
import builder from './impl/controller';
import {
    bindServiceWorkerController,
    injectServiceWorkerController,
    unbindServiceWorkerController,
} from './interface';

const bindJobs: Array<{
    bind: (container: IContainer) => void;
    remove: (container: IContainer) => void;
    expose: (srcContainer: IContainer, dstContainer: IContainer) => void;
}> = [
    {
        bind: (container: IContainer) => {
            /* must initialized before, otherwise each call to injectServiceWorkerController, will result in a separate instance */
            const result = builder(container);
            bindServiceWorkerController(() => result, container);
        },
        remove: (container: IContainer) => unbindServiceWorkerController(container),
        expose: (srcContainer: IContainer, dstContainer: IContainer) =>
            bindServiceWorkerController(
                () => injectServiceWorkerController(srcContainer),
                dstContainer,
            ),
    },
];

const module = {
    bind: (container: IContainer) => bindJobs.forEach(binder => binder.bind(container)),
    unbind: (container: IContainer) => bindJobs.forEach(binder => binder.remove(container)),
    expose: (srcContainer: IContainer, dstContainer: IContainer) =>
        bindJobs.forEach(binder => binder.expose(srcContainer, dstContainer)),
};

export default module;
